/**
 * US State center coordinates and zoom levels for the map selector.
 */

export const STATE_CENTERS = {
  AL: { lat: 32.3182, lng: -86.9023, zoom: 7 },
  AK: { lat: 64.2008, lng: -152.4937, zoom: 4 },
  AZ: { lat: 34.0489, lng: -111.0937, zoom: 7 },
  AR: { lat: 34.7465, lng: -92.2896, zoom: 7 },
  CA: { lat: 36.7783, lng: -119.4179, zoom: 6 },
  CO: { lat: 39.5501, lng: -105.7821, zoom: 7 },
  CT: { lat: 41.6032, lng: -73.0877, zoom: 9 },
  DE: { lat: 38.9108, lng: -75.5277, zoom: 9 },
  DC: { lat: 38.9072, lng: -77.0369, zoom: 12 },
  FL: { lat: 27.6648, lng: -81.5158, zoom: 7 },
  GA: { lat: 32.1656, lng: -82.9001, zoom: 7 },
  HI: { lat: 19.8968, lng: -155.5828, zoom: 7 },
  ID: { lat: 44.0682, lng: -114.742, zoom: 6 },
  IL: { lat: 40.6331, lng: -89.3985, zoom: 7 },
  IN: { lat: 39.7684, lng: -86.1581, zoom: 7 },
  IA: { lat: 41.878, lng: -93.0977, zoom: 7 },
  KS: { lat: 39.0119, lng: -98.4842, zoom: 7 },
  KY: { lat: 37.8393, lng: -84.27, zoom: 7 },
  LA: { lat: 30.9843, lng: -91.9623, zoom: 7 },
  ME: { lat: 45.2538, lng: -69.4455, zoom: 7 },
  MD: { lat: 39.0458, lng: -76.6413, zoom: 8 },
  MA: { lat: 42.4072, lng: -71.3824, zoom: 8 },
  MI: { lat: 44.3148, lng: -85.6024, zoom: 7 },
  MN: { lat: 46.7296, lng: -94.6859, zoom: 7 },
  MS: { lat: 32.3547, lng: -89.3985, zoom: 7 },
  MO: { lat: 37.9643, lng: -91.8318, zoom: 7 },
  MT: { lat: 46.8797, lng: -110.3626, zoom: 6 },
  NE: { lat: 41.4925, lng: -99.9018, zoom: 7 },
  NV: { lat: 38.8026, lng: -116.4194, zoom: 7 },
  NH: { lat: 43.1939, lng: -71.5724, zoom: 8 },
  NJ: { lat: 40.0583, lng: -74.4057, zoom: 8 },
  NM: { lat: 34.5199, lng: -105.8701, zoom: 7 },
  NY: { lat: 42.1657, lng: -74.9481, zoom: 7 },
  NC: { lat: 35.7596, lng: -79.0193, zoom: 7 },
  ND: { lat: 47.5515, lng: -101.002, zoom: 7 },
  OH: { lat: 40.4173, lng: -82.9071, zoom: 7 },
  OK: { lat: 35.0078, lng: -97.0929, zoom: 7 },
  OR: { lat: 43.8041, lng: -120.5542, zoom: 7 },
  PA: { lat: 41.2033, lng: -77.1945, zoom: 7 },
  RI: { lat: 41.5801, lng: -71.4774, zoom: 10 },
  SC: { lat: 33.8361, lng: -81.1637, zoom: 7 },
  SD: { lat: 43.9695, lng: -99.9018, zoom: 7 },
  TN: { lat: 35.5175, lng: -86.5804, zoom: 7 },
  TX: { lat: 31.9686, lng: -99.9018, zoom: 6 },
  UT: { lat: 39.3210, lng: -111.0937, zoom: 7 },
  VT: { lat: 44.5588, lng: -72.5778, zoom: 8 },
  VA: { lat: 37.4316, lng: -78.6569, zoom: 7 },
  WA: { lat: 47.7511, lng: -120.7401, zoom: 7 },
  WV: { lat: 38.5976, lng: -80.4549, zoom: 7 },
  WI: { lat: 43.7844, lng: -88.7879, zoom: 7 },
  WY: { lat: 43.0760, lng: -107.2903, zoom: 7 },
};

export const US_STATES = [
  { code: 'AL', name: 'Alabama' },
  { code: 'AK', name: 'Alaska' },
  { code: 'AZ', name: 'Arizona' },
  { code: 'AR', name: 'Arkansas' },
  { code: 'CA', name: 'California' },
  { code: 'CO', name: 'Colorado' },
  { code: 'CT', name: 'Connecticut' },
  { code: 'DE', name: 'Delaware' },
  { code: 'DC', name: 'Washington DC' },
  { code: 'FL', name: 'Florida' },
  { code: 'GA', name: 'Georgia' },
  { code: 'HI', name: 'Hawaii' },
  { code: 'ID', name: 'Idaho' },
  { code: 'IL', name: 'Illinois' },
  { code: 'IN', name: 'Indiana' },
  { code: 'IA', name: 'Iowa' },
  { code: 'KS', name: 'Kansas' },
  { code: 'KY', name: 'Kentucky' },
  { code: 'LA', name: 'Louisiana' },
  { code: 'ME', name: 'Maine' },
  { code: 'MD', name: 'Maryland' },
  { code: 'MA', name: 'Massachusetts' },
  { code: 'MI', name: 'Michigan' },
  { code: 'MN', name: 'Minnesota' },
  { code: 'MS', name: 'Mississippi' },
  { code: 'MO', name: 'Missouri' },
  { code: 'MT', name: 'Montana' },
  { code: 'NE', name: 'Nebraska' },
  { code: 'NV', name: 'Nevada' },
  { code: 'NH', name: 'New Hampshire' },
  { code: 'NJ', name: 'New Jersey' },
  { code: 'NM', name: 'New Mexico' },
  { code: 'NY', name: 'New York' },
  { code: 'NC', name: 'North Carolina' },
  { code: 'ND', name: 'North Dakota' },
  { code: 'OH', name: 'Ohio' },
  { code: 'OK', name: 'Oklahoma' },
  { code: 'OR', name: 'Oregon' },
  { code: 'PA', name: 'Pennsylvania' },
  { code: 'RI', name: 'Rhode Island' },
  { code: 'SC', name: 'South Carolina' },
  { code: 'SD', name: 'South Dakota' },
  { code: 'TN', name: 'Tennessee' },
  { code: 'TX', name: 'Texas' },
  { code: 'UT', name: 'Utah' },
  { code: 'VT', name: 'Vermont' },
  { code: 'VA', name: 'Virginia' },
  { code: 'WA', name: 'Washington' },
  { code: 'WV', name: 'West Virginia' },
  { code: 'WI', name: 'Wisconsin' },
  { code: 'WY', name: 'Wyoming' },
];
